import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcBusinessman, FcFilmReel } from "react-icons/fc";
import { guestInfo } from "../../../SchemaInfo/info";
import { guestSchema } from "../../../Schemas/Media And Marketing/guest_management.schema";
import { useEffect } from "react";

const EditGuestDetails = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [guestDataInfo, setGuestDataInfo] = useState(guestInfo);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/guest/get-guest/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setGuestDataInfo(res.data);
        } else {
          Toast("error", "Error while getting guest!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handelSubmit = (values) => {
    performRequest("PATCH", `/guest/update/${id}`, values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "guest updated successfully!");
          navigate(`/guest-view/${id}`);
        } else {
          Toast("error", "Error while updating guest");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcBusinessman></FcBusinessman> Guest Management
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Edit Guest Details</h2>
            </div>
            <Formik
              initialValues={guestDataInfo}
              validationSchema={guestSchema}
              onSubmit={handelSubmit}
              enableReinitialize={true}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Guest Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="guestName"
                        ></CustomInput>
                        {props.touched.guestName && props.errors.guestName && (
                          <p className="text-danger">
                            {" "}
                            {props.errors.guestName}{" "}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Guest Business Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="guestBusinessName"
                        ></CustomInput>
                        {props.touched.guestBusinessName &&
                          props.errors.guestBusinessName && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.guestBusinessName}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Guest Description
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type={"text"}
                          className="form-control"
                          name="guestDescription"
                        ></CustomTextArea>
                        {props.touched.guestDescription &&
                          props.errors.guestDescription && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.guestDescription}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Current Guest Podcast
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="guestPodcast"
                          placeholder="Paste current podcast of that guest on
                        other channel"
                        ></CustomInput>
                        {props.touched.guestPodcast &&
                          props.errors.guestPodcast && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.guestPodcast}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Guest Contact Number
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="guestContactNum"
                        ></CustomInput>
                        {props.touched.guestContactNum &&
                          props.errors.guestContactNum && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.guestContactNum}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Guest Email Id
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="guestEmailId"
                        ></CustomInput>
                        {props.touched.guestEmailId &&
                          props.errors.guestEmailId && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.guestEmailId}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Guest Instagram profile
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="guestInstaProfile"
                        ></CustomInput>
                        {props.touched.guestInstaProfile &&
                          props.errors.guestInstaProfile && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.guestInstaProfile}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-3 form-label">
                        Guest Interested In
                      </label>

                      <div className="col-9 d-flex gap-4 align-items-center">
                        {/* YES */}
                        <label className="form-check">
                          <input
                            type="radio"
                            name="guestIntrested"
                            value="yes"
                            className="form-check-input"
                            checked={props.values.guestIntrested === "yes"}
                            onChange={props.handleChange}
                          />
                          <span className="form-check-label">Yes</span>
                        </label>

                        {/* NO */}
                        <label className="form-check">
                          <input
                            type="radio"
                            name="guestIntrested"
                            value="no"
                            className="form-check-input"
                            checked={props.values.guestIntrested === "no"}
                            onChange={props.handleChange}
                          />
                          <span className="form-check-label">No</span>
                        </label>
                      </div>

                      {/* Error (ONLY ONCE) */}
                      <div className="col-9 offset-3">
                        {props.touched.guestIntrested &&
                          props.errors.guestIntrested && (
                            <p className="text-danger mb-0">
                              {props.errors.guestIntrested}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Edit Guest Details" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default EditGuestDetails;
